import type from "./sections/type"
import colors from "./sections/colors"
import animations from "./sections/animations"
import zindex from "./sections/zindex"
import mq from "./sections/mq"
import grid from "./sections/grid"

const index = {
  ...type,
  ...colors,
  ...animations,
  ...zindex,
  ...mq,
  ...grid,
}

export default index
